import {
  ADD_MOVEOUT_CHECKLIST_ITEM,
  ADD_EMAIL_CADENCE_ITEM,
  UPDATE_EMAIL_SUBJECT_LINE,
  UPDATE_EMAIL_INTRODUCTION,
  UPDATE_BUILDING_ID,
} from '../actions/types'

const defaultState = {
  checklist: [],
  emailCadence: [],
  emailSubjectLine: '',
  emailIntroduction: '',
  buildingId: '',
}

const moveOutState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case ADD_MOVEOUT_CHECKLIST_ITEM:
      return {
        ...state,
        checklist: [...state.checklist, payload],
      }
    case ADD_EMAIL_CADENCE_ITEM:
      return {
        ...state,
        emailCadence: [...state.emailCadence, payload],
      }
    case UPDATE_EMAIL_SUBJECT_LINE:
      return {
        ...state,
        emailSubjectLine: payload,
      }
    case UPDATE_EMAIL_INTRODUCTION:
      return {
        ...state,
        emailIntroduction: payload,
      }
    case UPDATE_BUILDING_ID:
      return {
        ...state,
        buildingId: payload.buildingId,
        emailCadence: payload.cadences,
        emailSubjectLine: payload.email
          ? payload.email.subject || ''
          : '',
        emailIntroduction: payload.email
          ? payload.email.openingBody || ''
          : '',
        checklist: payload.checklist,
      }
    default:
      return state
  }
}

export default moveOutState
